import React, { useEffect, useState } from "react";
import { CompanyDto } from "../../../api/companies";
import { getCompanies } from "../../../api/companies";
import { CompanyModal } from "../../Companies/CompanyModal";

import "../../../styles/warehouse/supplier-tab.css";

export default SupplierTab;


export function SupplierTab() {
  const [suppliers, setSuppliers] = useState<CompanyDto[]>([]);
  const [loading, setLoading] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState<CompanyDto | null>(null);

  useEffect(() => {
    loadSuppliers();
  }, []);

  async function loadSuppliers() {
    setLoading(true);
    const companies = await getCompanies();
    const filtered = companies.filter((c) => c.roles.includes("supplier"));
    setSuppliers(filtered);
    setLoading(false);
  }

  function openCreateModal() {
    setSelectedSupplier(null);
    setModalOpen(true);
  }

  function openEditModal(supplier: CompanyDto) {
    setSelectedSupplier(supplier);
    setModalOpen(true);
  }

  function closeModal() {
    setModalOpen(false);
    loadSuppliers();
  }

  return (
    <div className="settings-section-card">
      <div className="settings-header">
        <h2>Поставщики</h2>
        <button className="btn-primary" onClick={openCreateModal}>
          Добавить поставщика
        </button>
      </div>

      {loading ? (
        <div style={{ padding: 20 }}>Загрузка...</div>
      ) : (
        <table className="users-table">
          <thead>
            <tr>
              <th>Название</th>
              <th>БИН</th>
              <th>Телефон</th>
              <th>Email</th>
              <th>Основной контакт</th>
              <th>Директор</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {suppliers.map((s) => {
              const mainContact = s.contacts?.find((c) => c.isMain);

              return (
                <tr key={s.id}>
                  <td>{s.name}</td>
                  <td>{s.bin}</td>
                  <td>{s.phone}</td>
                  <td>{s.email}</td>
                  <td>{mainContact ? mainContact.name : "—"}</td>
                  <td>{s.director}</td>
                  <td style={{ textAlign: "right" }}>
                    <button className="btn-edit" onClick={() => openEditModal(s)}>
                      Открыть
                    </button>
                  </td>
                </tr>
              );
            })}

            {suppliers.length === 0 && (
              <tr>
                <td colSpan={7} style={{ padding: "14px 16px", opacity: 0.7 }}>
                  Поставщиков пока нет
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      {modalOpen && (
        <CompanyModal
          company={
            selectedSupplier
              ? selectedSupplier
              : { id: undefined, roles: ["supplier"], contacts: [] } as any
          }
          onClose={closeModal}
        />
      )}
    </div>
  );
}